import React from 'react';
import VideoGallery from './components/VideoGallery';

function App() {
  return (
    <div>
      <VideoGallery />
    </div>
  );
}

export default App;
